import Create from './Create';
import Edit from './Edit';
import List from './List';
import Show from './Show';

export {
  Create,
  Edit,
  List,
  Show,
};



// WEBPACK FOOTER //
// ./src/components/Offer/index.js